/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim1HIcon20Solid = forwardRef('ArrowDim1HIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M6.634 4.616a1.25 1.25 0 0 1 0 1.768L4.268 8.75h11.464l-2.366-2.366a1.25 1.25 0 0 1 1.768-1.768l3.616 3.616a2.5 2.5 0 0 1 0 3.536l-3.616 3.616a1.25 1.25 0 0 1-1.768-1.768l2.367-2.367H4.267l2.367 2.367a1.25 1.25 0 0 1-1.768 1.768L1.25 11.768a2.5 2.5 0 0 1 0-3.536l3.616-3.616a1.25 1.25 0 0 1 1.768 0Z" })));
});
